module.exports = "/static/assets/510201fee0eb0012cff8c51de7573726.png";